// extracted by mini-css-extract-plugin
export default {"titleText":"ActionsContainer_titleText__dVTk1"};